"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/policySummaryService',["require", "exports", "routing/mainRouter", "controllers/policySummaryController", "models/userIdentityModel"], function (require, exports, mainRouter, policySummaryController, userIdentityModel) {
    "use strict";

    var PolicySummaryService = function () {
        function PolicySummaryService() {
            _classCallCheck(this, PolicySummaryService);
        }

        _createClass(PolicySummaryService, [{
            key: "getPolicySummary",
            value: function getPolicySummary(policyId, coverStartDate, coverEndDate, coverCancelledDate, date, enviroment) {
                return policySummaryController.getPolicySummary({
                    environment: enviroment || this.getEnvironment(),
                    policyId: policyId,
                    insurerId: userIdentityModel.insurerId(),
                    date: date,
                    coverStartDate: coverStartDate,
                    coverEndDate: coverEndDate,
                    coverCancelledDate: coverCancelledDate
                });
            }
        }, {
            key: "getPolicySummaryBlob",
            value: function getPolicySummaryBlob(policyId, brokerPolicyId, policyholderName, policyholderId, coverStartDate, requesterTile, allowMultipleOverride) {
                return policySummaryController.getPolicySummaryBlob({
                    environment: this.getEnvironment(),
                    policyId: policyId,
                    brokerPolicyId: brokerPolicyId,
                    policyholderId: policyholderId,
                    policyholderName: policyholderName,
                    insurerId: userIdentityModel.insurerId(),
                    coverStartDate: coverStartDate,
                    requesterTile: requesterTile
                }, allowMultipleOverride);
            }
        }, {
            key: "getEnvironment",
            value: function getEnvironment() {
                return mainRouter.router.environmentId();
            }
        }]);

        return PolicySummaryService;
    }();

    return new PolicySummaryService();
});
//# sourceMappingURL=policySummaryService.js.map;
